import { ViewIds } from '@ardoq/api-types';
import type { ViewpointModeViewKey } from 'views/environmentals/viewSettings/types';

export const AI_VIEW_IDS = [
  ViewIds.MODERNIZED_BLOCK_DIAGRAM,
  ViewIds.COMPONENT_MATRIX_2,
  ViewIds.DEPENDENCY_MAP_2,
  ViewIds.RELATIONSHIPS_3,
  ViewIds.BUBBLE,
  ViewIds.TIMELINE,
  ViewIds.FLEXIBLE_BLOCK_DIAGRAM,
  ViewIds.BLOCKS,
] as const satisfies readonly ViewpointModeViewKey[];

export type AiViewId = (typeof AI_VIEW_IDS)[number];
